import "core-js/stable";
import "regenerator-runtime/runtime";
import './plugins/axios'
import './plugins/vuejs-logger'
import App from './App.vue'
import {router} from './_helpers'
import {store} from './_store'
import './registerServiceWorker'
import {VueReCaptcha} from 'vue-recaptcha-v3';

import "@/styles/main.scss"

import {createApp} from "vue";
import {vuetify} from "@/plugins/vuetify";
import VueLogger from "vuejs3-logger";
import {options} from "@/plugins/vuejs-logger";
import {LoadingPlugin} from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

// @modified daniel.silva 2019.07.05 not used at this moment
//import './plugins/vue2-google-maps'
import VueQrcode from '@chenfengyuan/vue-qrcode';
import {MazUi} from 'maz-ui/plugins/maz-ui'
import {pristine} from '@maz-ui/themes'
import 'maz-ui/styles'

const app = createApp(App);

// @daniel.silva 2019.07.05 IMPORTANT!! set recaptcha api url
// TODO Review, only working in Firefox atm
var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
if (isFirefox) {
    window["__recaptcha_api"] = "https://www.recaptcha.net/recaptcha/";
}

app.use(MazUi, {
    theme: {
        preset: pristine,
        colorMode: 'light'
    }
})

app.use(VueReCaptcha, {
    siteKey: process.env.NODE_ENV === 'production' ? '6Ld29ZkUAAAAAJrisAhrp_q3fl-M2hehMMh-gqF7' : '6LeL9poUAAAAAGSsJ22QsL27yREFnXPx4lx5HAVn',
    loaderOptions: {
        useRecaptchaNet: true,
        autoHideBadge: true
    }
});

app.component(VueQrcode.name, VueQrcode);

app.config.productionTip = false;


app.use(VueLogger, options);
app.use(LoadingPlugin);

app.use(router)
app.use(store)
app.use(vuetify)

app.mount("#app");

export default app;
